import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbThePipsInsights = () => {
  return (
    <div
      className="ht__bradcaump__area__resource"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>The Pips Insights</h1>
              <p>
                Unpack market trends, strategies, and economic updates, your
                gateway to smarter trading decisions powered by real analysis.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Explore Insights
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbThePipsInsights.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbThePipsInsights;
